import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../Contexts/UserAuthContextProvider';
import useTitle from '../../hooks/useTitle';
import MyReviewsRow from './MyReviewsRow';

const MyReviews = () => {
    useTitle('MyReviews-Bakeri');

    const { user } = useContext(AuthContext);
    const [myreviews, setMyreviews] = useState([]);

    // ____________________________________________
    //_______fetch myreviews based on user email___
    useEffect(() => {
        fetch(`https://bakery-server.vercel.app/reviews?email=${user.email}`, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('token')}`
            }
        }
        )
            .then(res =>{
                // if (res.status === 401 || res.status === 403) {
                //     console.log(res.json())
                //     // return logout();
                // }
                console.log('after fetching successfully or not')
                return res.json()}
            )
            .then(data => { console.log(data); setMyreviews(data) })

    }, [user.email])


    // ____________________________________________
    //_______ handle review update ___

    // ____________________________________________
    //_______ handle review delete ___
    const handleReviewDelete = id => {
        fetch(`https://bakery-server.vercel.app/reviews/${id}`, {
            method: 'DELETE',
        })
            .then(res => res.json())
            .then(data => {
                if (data.deletedCount > 0) {
                    alert('deleted successfully')
                    const remainingReviews = myreviews.filter(review => review._id !== id);
                    setMyreviews(remainingReviews);
                }
            })
    }
    // _______________________________________________________________________

    return (
        <>
            {
                myreviews.length > 0 ?
                    <div className='my-3'>
                        <div className="overflow-x-auto w-full">
                            <table className="table w-full">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Review</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        myreviews?.map(review =>
                                            <MyReviewsRow
                                                key={review._id}
                                                myreview={review}
                                                handleReviewDelete={handleReviewDelete}
                                            ></MyReviewsRow>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    : <div className='h-[50vh] flex items-center justify-center text-xl font-semibold'>
                        No reviews yet
                    </div>
            }
        </>
    );
};

export default MyReviews;